var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBevoKonservierungsstoffe48(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.1,17.2c0.6,0,1.1-0.5,1.1-1.2s-0.5-1.2-1.1-1.2c-0.6,0-1.1,0.5-1.1,1.2S22.5,17.2,23.1,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,14.8c0.6,0,1.1-0.5,1.1-1.2s-0.5-1.2-1.1-1.2c-0.6,0-1.1,0.5-1.1,1.2S25.4,14.8,26,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9,33.1l-3-10.1v-2.4h0.9v-2.1h-2.4h-0.6h-2.4v2.1h0.9V23l-3,10.1c0,0-0.7,2.4,1.1,2.4H24H24c0,0,1.9,0,3.7,0 S28.9,33.1,28.9,33.1z M23,27.3c0.6,0,1.1,0.5,1.1,1.2s-0.5,1.2-1.1,1.2c-0.6,0-1.1-0.5-1.1-1.2S22.5,27.3,23,27.3z M26.9,34.3 l-3-0.1l-2.8,0.1c0,0-0.9,0.1-0.7-0.8c0.2-1.2,0.2-1.2,0.2-1.2s0-0.2,0.5-0.2c0.3,0,0.6,0.3,1.1,0.1c0.5-0.2,0.5-0.6,1.9-0.6 c0,0,0,0,0,0h0c0,0,0,0,0,0c1.3,0,1.4,0.3,1.9,0.6c0.5,0.2,0.8-0.1,1.1-0.1c0.5,0,0.5,0.2,0.5,0.2s0,0,0.2,1.2 C27.8,34.4,26.9,34.3,26.9,34.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBevoKonservierungsstoffe48);
export default __webpack_public_path__ + "static/media/ic_bevo_konservierungsstoffe_48.0f38d27e7f4a4fa62ff23127c3e5095a.svg";
export { ForwardRef as ReactComponent };